export const destinations = [
	{
		slug: "varna-to-golden-sands",
		title: "Varna to Golden Sands",
		modalTitle: "Varna to Golden Sands Taxi Transfer",
		price: "€35",
		priceNote: "fixed price",
		metaTitle:
			"Varna to Golden Sands Taxi Transfer | Fixed €35 | Airport Taxi Varna",
		metaDescription:
			"Book a private taxi from Varna Airport or Varna city to Golden Sands. Fixed price €35, English-speaking driver, 24/7. Door-to-door transfer along the Black Sea coast.",
		keywords:
			"Varna to Golden Sands taxi, Golden Sands airport transfer, Varna airport taxi Golden Sands",
		heroSubtitle:
			"Door-to-door private transfer from Varna Airport or city centre to Golden Sands resort.",
		routeDistance: "~18 km",
		routeDuration: "~25 min",
		description:
			"Private taxi transfer from Varna city or Varna Airport to Golden Sands resort. Comfortable vehicles, professional driver and door-to-door service.",
		about: [
			"Golden Sands is one of Bulgaria's most popular seaside resorts, located north of Varna along the Black Sea coast. Our private transfer service takes you directly from Varna Airport (VAR) or any address in Varna to your hotel, apartment, or villa in Golden Sands — without shared shuttles or hidden fees.",
			"Whether you are arriving on a late flight or travelling with family, we offer fixed pricing, free waiting time at the airport, and child seats on request. Pay by card or cash and enjoy a comfortable ride with an English-speaking driver who knows the resort area well.",
		],
		highlights: [
			"Ideal for airport arrivals at Varna (VAR)",
			"Popular with families and holiday groups",
			"Short coastal drive — typically under 30 minutes",
		],
		included: [
			"Fixed price – no hidden fees",
			"English speaking driver",
			"Card & cash payment",
			"Child seat on request",
			"24/7 service",
		],
	},
	{
		slug: "varna-to-albena",
		title: "Varna to Albena",
		modalTitle: "Varna to Albena Taxi Transfer",
		price: "€50",
		priceNote: "fixed price",
		metaTitle:
			"Varna to Albena Taxi Transfer | Fixed €50 | Airport Taxi Varna",
		metaDescription:
			"Reliable private transfer from Varna Airport to Albena resort. Fixed €50, professional driver, door-to-door service. Book online 24/7.",
		keywords:
			"Varna to Albena taxi, Albena airport transfer, Varna private transfer Albena",
		heroSubtitle:
			"Fast, comfortable private transfer from Varna or Varna Airport to Albena resort.",
		routeDistance: "~30 km",
		routeDuration: "~35 min",
		description:
			"Private transfer from Varna or Varna Airport to Albena resort. Fast and reliable taxi service with comfortable vehicles.",
		about: [
			"Albena is a well-known family-friendly resort on the Bulgarian Black Sea coast, north of Golden Sands. We provide direct private transfers from Varna Airport and Varna city to any accommodation in Albena with a clear fixed fare and no surge pricing.",
			"Our drivers meet you at arrivals with a name sign when requested, help with luggage, and take the most efficient route to your destination. Book in advance for peace of mind, especially during the summer season.",
		],
		highlights: [
			"Family-friendly resort transfers",
			"Meet & greet at Varna Airport available",
			"Fixed fare — no meter surprises",
		],
		included: [
			"Fixed price",
			"Door-to-door transfer",
			"English speaking driver",
			"Card payment accepted",
			"Child seat available",
			"24/7 service",
		],
	},
	{
		slug: "varna-to-kranevo",
		title: "Varna to Kranevo",
		modalTitle: "Varna to Kranevo Taxi Transfer",
		price: "€45",
		priceNote: "fixed price",
		metaTitle:
			"Varna to Kranevo Taxi Transfer | Fixed €45 | Airport Taxi Varna",
		metaDescription:
			"Private taxi from Varna to Kranevo resort. Fixed €45, safe door-to-door transfer, English-speaking driver. Available 24/7.",
		keywords:
			"Varna to Kranevo taxi, Kranevo transfer, Varna airport taxi Kranevo",
		heroSubtitle:
			"Safe, direct private transportation between Varna and Kranevo resort.",
		routeDistance: "~25 km",
		routeDuration: "~30 min",
		description:
			"Private taxi transfer between Varna and Kranevo resort. Safe, comfortable and direct transportation.",
		about: [
			"Kranevo is a quieter coastal village between Albena and Golden Sands, popular with visitors who prefer a relaxed atmosphere close to the main resorts. Our Varna to Kranevo taxi service offers a straightforward fixed-price journey from the airport or city.",
			"Choose a private car instead of waiting for buses or negotiating at the rank — ideal for couples, small groups, and travellers with children. We operate around the clock and accept card payments for your convenience.",
		],
		highlights: [
			"Quiet resort area — ideal for relaxed holidays",
			"Close to Albena and Golden Sands",
			"24/7 availability year-round",
		],
		included: [
			"Fixed price",
			"Professional driver",
			"Card & cash payment",
			"Child seat on request",
			"24/7 availability",
		],
	},
	{
		slug: "varna-to-balchik",
		title: "Varna to Balchik",
		modalTitle: "Varna to Balchik Taxi Transfer",
		price: "€55",
		priceNote: "fixed price",
		metaTitle:
			"Varna to Balchik Taxi Transfer | Fixed €55 | Airport Taxi Varna",
		metaDescription:
			"Comfortable private transfer from Varna Airport to Balchik. Fixed €55, tourist-friendly service, English-speaking driver. Book your taxi online.",
		keywords:
			"Varna to Balchik taxi, Balchik airport transfer, Varna private taxi Balchik",
		heroSubtitle:
			"Comfortable private transfer to Balchik — perfect for tourists and airport arrivals.",
		routeDistance: "~40 km",
		routeDuration: "~45 min",
		description:
			"Comfortable private transfer from Varna city or Varna Airport to Balchik. Ideal for tourists and airport transfers.",
		about: [
			"Balchik is famous for its Botanical Garden, Queen Marie's Palace, and scenic coastline north of Varna. Visitors often combine a stay in Balchik with day trips along the coast — our transfer service connects you seamlessly from Varna Airport or downtown Varna.",
			"We serve hotels, guest houses, and private addresses throughout Balchik. Fixed pricing means you know the cost before you travel, with all taxes included and no extra charges for luggage within reasonable limits.",
		],
		highlights: [
			"Popular with cultural and sightseeing visitors",
			"Scenic route along the northern Black Sea coast",
			"Botanical Garden & palace area coverage",
		],
		included: [
			"Fixed price",
			"Door-to-door service",
			"English speaking driver",
			"Card payment accepted",
			"Child seat available",
		],
	},
	{
		slug: "varna-to-sunny-beach",
		title: "Varna to Sunny Beach",
		modalTitle: "Varna to Sunny Beach Taxi Transfer",
		price: "€130",
		priceNote: "fixed price",
		metaTitle:
			"Varna to Sunny Beach Taxi Transfer | Fixed €130 | Airport Taxi Varna",
		metaDescription:
			"Long-distance private taxi from Varna to Sunny Beach. Fixed €130, comfortable vehicles, professional driver. Direct resort transfer 24/7.",
		keywords:
			"Varna to Sunny Beach taxi, Sunny Beach transfer from Varna, Varna airport Sunny Beach",
		heroSubtitle:
			"Long-distance private transfer to Sunny Beach — comfortable, reliable, fixed price.",
		routeDistance: "~100 km",
		routeDuration: "~1h 30min",
		description:
			"Long distance private taxi transfer from Varna to Sunny Beach resort. Comfortable vehicles and reliable service.",
		about: [
			"Sunny Beach is Bulgaria's largest seaside resort, located south of Varna towards Burgas. The journey is longer than coastal routes to Golden Sands or Albena, which is why we offer a dedicated long-distance rate with comfortable vehicles suited to motorway travel.",
			"Whether you are heading to a hotel in Sunny Beach, Sveti Vlas, or nearby Nessebar, our driver will take you door-to-door from Varna Airport or city. Air conditioning, ample boot space, and rest stops on request make the trip pleasant for families and groups.",
		],
		highlights: [
			"Bulgaria's largest beach resort destination",
			"Comfortable long-distance vehicles",
			"Also serves Sveti Vlas & Nessebar area",
		],
		included: [
			"Fixed price",
			"Direct transfer",
			"Professional driver",
			"Card & cash payment",
			"24/7 service",
		],
	},
	{
		slug: "varna-to-burgas",
		title: "Varna to Burgas",
		modalTitle: "Varna to Burgas Taxi Transfer",
		price: "€150",
		priceNote: "fixed price",
		metaTitle:
			"Varna to Burgas Taxi Transfer | Fixed €150 | Airport Taxi Varna",
		metaDescription:
			"Private transfer from Varna to Burgas city or airport. Fixed €150, door-to-door, English-speaking driver. Book your inter-city taxi online.",
		keywords:
			"Varna to Burgas taxi, Burgas transfer from Varna, Varna Burgas private car",
		heroSubtitle:
			"Inter-city private transfer between Varna and Burgas with fixed pricing.",
		routeDistance: "~130 km",
		routeDuration: "~2 hours",
		description:
			"Private transfer between Varna and Burgas with fixed pricing and comfortable travel.",
		about: [
			"Burgas is the second-largest city on the Bulgarian Black Sea coast and home to Burgas Airport (BOJ), a gateway to Sunny Beach, Sozopol, and the southern resorts. Our Varna to Burgas transfer is ideal for travellers continuing their journey south or connecting between airports.",
			"We pick up from Varna Airport, Varna city, or any specified address and deliver you to Burgas city centre, the port, or Burgas Airport. Enjoy a private car with a professional driver rather than multiple bus changes with luggage.",
		],
		highlights: [
			"City-to-city & airport connections",
			"Links southern resorts via Burgas",
			"Ideal for multi-destination itineraries",
		],
		included: [
			"Fixed price",
			"Door-to-door transfer",
			"English speaking driver",
			"Card payment accepted",
			"24/7 availability",
		],
	},
	{
		slug: "varna-to-bucharest",
		title: "Varna to Bucharest",
		modalTitle: "Varna to Bucharest Taxi Transfer",
		price: "€300",
		priceNote: "fixed price",
		metaTitle:
			"Varna to Bucharest Taxi Transfer | Cross-Border €300 | Airport Taxi Varna",
		metaDescription:
			"Private international transfer from Varna, Bulgaria to Bucharest, Romania. Fixed €300, cross-border taxi, comfortable long-distance travel. Book 24/7.",
		keywords:
			"Varna to Bucharest taxi, cross border transfer Varna Bucharest, Varna Romania taxi",
		heroSubtitle:
			"International private transfer from Varna, Bulgaria to Bucharest, Romania.",
		routeDistance: "~360 km",
		routeDuration: "~4–5 hours",
		description:
			"Private international transfer from Varna to Bucharest. Ideal for business or tourist travel with comfortable long-distance service.",
		about: [
			"Travelling from Varna to Bucharest requires crossing the Bulgaria–Romania border. Our cross-border private transfer service provides a comfortable, direct journey in a suitable vehicle with an experienced driver familiar with the route and border procedures.",
			"Perfect for business travellers, tourists extending their trip into Romania, or groups who prefer a private car over flights or trains. We offer fixed pricing, help with luggage, and flexible pickup from Varna Airport, city hotels, or any agreed location.",
		],
		highlights: [
			"Cross-border Bulgaria → Romania",
			"Business & leisure long-distance travel",
			"Experienced drivers on international routes",
		],
		included: [
			"Fixed price",
			"Cross-border transfer",
			"Professional driver",
			"Card & cash payment",
			"Comfortable vehicle",
		],
	},
];

export const getDestinationBySlug = (slug) =>
	destinations.find((destination) => destination.slug === slug);
